/**
 * This is only meant to be used for `objectResolverClient.countResolvableUrls` for load
 * analysis and estimations for loading public links using the Smart Links service.
 *
 * https://bitbucket.org/atlassian/forge-smart-links/src/master/resolvers/iframely/manifest.template.yml
 * https://team.atlassian.com/project/ATLAS-238
 */

const patterns = [
  { source: 'https:\\/\\/calendly.com', flags: '' },
  { source: 'https:\\/\\/docs.aws.amazon.com', flags: '' },
  {
    source: 'https:\\/\\/facebook.com|https:\\/\\/www.facebook.com',
    flags: '',
  },
  { source: 'https:\\/\\/github.com|https:\\/\\/www.github.com', flags: '' },
  {
    source: 'https:\\/\\/instagram.com|https:\\/\\/www.instagram.com',
    flags: '',
  },
  {
    source: 'https:\\/\\/linkedin.com|https:\\/\\/www.linkedin.com',
    flags: '',
  },
  { source: 'https:\\/\\/loom.com|https:\\/\\/www.loom.com', flags: '' },
  { source: 'https:\\/\\/overflow.io|https:\\/\\/www.overflow.io', flags: '' },
  { source: 'https:\\/\\/twitter.com|https:\\/\\/www.twitter.com', flags: '' },
  { source: 'https:\\/\\/youtu.be|https:\\/\\/www.youtu.be', flags: '' },
  { source: 'https:\\/\\/youtube.com|https:\\/\\/www.youtube.com', flags: '' },
];

export const iframelyObjectProvider = {
  key: 'iframely-object-provider',
  patterns: patterns.map(
    (pattern) => new RegExp(pattern.source, pattern.flags),
  ),
};
